import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../i18n/constants/keys';
import { Button } from '../../ui';

export const Unauthorized = () => {
  const history = useHistory();
  const { t } = useTranslation(NS.adminPages);
  const UA = ADMIN_PAGES_KEYS.unauthorized;

  return (
    <div className='flex items-center justify-center  bg-gradient-to-br from-gray-100 to-gray-200 px-4'>
      <div className='bg-white rounded-2xl shadow-2xl p-10 max-w-xl w-full text-center animate-fade-in'>
        { /* Shield Lock Icon */ }
        <div className='w-44 h-44 mx-auto mb-6'>
          <svg
              className='w-full   h-full animate-pulse'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
          >
            <defs>
              <linearGradient
                  id='shieldLockGradient'
                  x1='0'
                  y1='0'
                  x2='0'
                  y2='24'
                  gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#059669' /> { /* emerald-600 */ }
                <stop offset='1' stopColor='#064e3b' /> { /* emerald-900 */ }
              </linearGradient>
            </defs>
            <path
                d='M12 2L4 5V11C4 16 7.5 20.5 12 22C16.5 20.5 20 16 20 11V5L12 2Z'
                fill='url(#shieldLockGradient)'
                stroke='#064e3b' /* emerald-900 */
                strokeWidth='1.5'
                filter='url(#glow)'
            />
            <path
                d='M9 11V9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9V11M10.5 14C10.5 13.1716 11.1716 12.5 12 12.5C12.8284 12.5 13.5 13.1716 13.5 14C13.5 14.8284 12.8284 15.5 12 15.5C11.1716 15.5 10.5 14.8284 10.5 14Z'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
          </svg>
        </div>

        { /* Message */ }
        <h1 className='text-3xl font-semibold text-gray-800 mb-2'>
          { t(UA.title) }
        </h1>
        <p className='text-gray-600 mb-6'>
          { t(UA.message) }
        </p>

        { /* Actions */ }
        <div className='flex flex-col sm:flex-row justify-center gap-4'>
          <Button
              onClick={() => history.push('/')}
              label={t(UA.goHome)}
              variant='primary'
          />
          <Button
              onClick={() => history.push('/login')}
              label={t(UA.loginAgain)}
              variant='secondary'
          />
        </div>
      </div>
    </div>
  );
};
